import React, { useState } from "react";
import { SideMenu, SideMenuItem, SideMenuTop } from "../../../components/components/molecules/SideMenu";
import { IconName } from "@telia/teddy";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../models";
import { getSalesAgent } from "../../state/selectors/selectors";
import { useLocation } from "react-router-dom";
import PAGES from "../../../../../constants/pages";
import SendFeedbackPanel from "../../components/molecules/SendFeedbackPanel/SendFeedbackPanel";

interface NavigationItem {
    label: string;
    path: string;
    icon?: IconName;
}

const navigationItems: NavigationItem[] = [
    {
        label: "Salg idag",
        path: PAGES.RETAILER.SALES_REPORTS.SALES_TODAY.URL,
        icon: "graph",
    },
    {
        label: "Salg siste måned",
        path: PAGES.RETAILER.SALES_REPORTS.SALES_LAST_MONTH.URL,
        icon: "pie-chart",
    },
    {
        label: "Provisjon",
        path: PAGES.RETAILER.SALES_REPORTS.COMMISSION.URL,
        icon: "money-back-kr",
    },
    /*
    {
        label: "SBI rapporter",
        path: PAGES.RETAILER.SALES_REPORTS.SBI_REPORTS.URL,
        icon: "report",
    },
    */
];

const SalesReportsSidebar: React.FC = () => {
    const location = useLocation();
    const isManager = useSelector((state: RootState) => getSalesAgent(state))?.isManager === true;
    const visibleItems = navigationItems.filter(
        (item) => isManager || item.path !== PAGES.RETAILER.SALES_REPORTS.COMMISSION.URL,
    );
    const [isReportErrorOpen, setIsReportErrorOpen] = useState(false);

    return (
        <div className="sidebar">
            <SideMenu className="sidebar__menu">
                <SideMenuTop>
                    {visibleItems.map((item) => (
                        <SideMenuItem
                            label={item.label}
                            color="grey"
                            icon={item.icon}
                            key={item.path}
                            onClick={() => window.location.assign(item.path)}
                            active={location.pathname === item.path}
                        />
                    ))}
                    <SideMenuItem
                        className="sidebar__menu-item--bottom"
                        label="Ny ordre"
                        color="grey"
                        icon="plus"
                        onClick={() => window.location.assign(PAGES.RETAILER.NEWORDER.URL)}
                    />
                    <SideMenuItem
                        label="Gi tilbakemelding"
                        color="grey"
                        icon="send"
                        onClick={() => setIsReportErrorOpen(true)}
                    />
                </SideMenuTop>
            </SideMenu>
            <SendFeedbackPanel open={isReportErrorOpen} onOpenChange={setIsReportErrorOpen} />
        </div>
    );
};

export default SalesReportsSidebar;
